import { Reducer } from 'redux';
import { generatedUUID, saveProgress } from '../../utils/localStorage';
import {
    SignupState,
    SIGNUP_SET,
    signupApiDto,
    SET_OFFICER_TITLES,
    SignupActions,
} from './types';

export const initialSignupState: SignupState = {
    uuid: generatedUUID(),
    organizationLocation: {
        userTypedValue: '',
        city: '',
        state: '',
        zip: '',
    },
    organizationName: '',
    organizationPhoneNumber: '',
    organizationZip: '',
    organizationAddress: '',
    organizationCountry: 'us',
    userTitle: '',
    userFirstName: '',
    userLastName: '',
    userEmail: '',
    userPhone: '',
    ein: '',
    doneeId: 0,
    doneeType: 'church',
    userPassword: '',
    organizationCity: '',
    organizationState: '',
    ypId: '',
    lat: '',
    lon: '',
    userTitles: [],
    fingerprint: '',
    selectedOrganization: null,
};

export const removeNumberFormatting = (phone: string | undefined): string =>
    phone?.replace(/\D+/g, '') || '';

export const addPhoneNumberFormatting = (phone: string | undefined) => {
    if (!phone) return '';
    const array = phone
        .toString()
        .replace(/\D+/g, '')
        .match(/^(\d{3})(\d{3})(\d{4})$/);
    if (!array || array.length < 4) return '';
    return `${array[1]}-${array[2]}-${array[3]}`;
};

const SignupReducer: Reducer<SignupState, SignupActions> = (
    state = initialSignupState,
    action,
) => {
    switch (action.type) {
        case SIGNUP_SET:
            if (action.signup.organizationPhoneNumber) {
                action.signup.organizationPhoneNumber = removeNumberFormatting(
                    action.signup.organizationPhoneNumber,
                );
            }
            if (action.signup.userPhone) {
                action.signup.userPhone = removeNumberFormatting(
                    action.signup.userPhone,
                );
            }
            const newState: SignupState = { ...state, ...action.signup };
            saveProgress(signupApiDto(newState));
            return newState;

        case SET_OFFICER_TITLES:
            return {
                ...state,
                userTitles: action.data,
            };
        case 'SET_FINGERPRINT':
            return {
                ...state,
                fingerprint: action.fingerprint,
            };
        default:
            return state;
    }
};

export default SignupReducer;
